import type { CollectionActionsProps, EntityCollection } from "@firecms/core";
import { ImportContentJsonButton } from "../actions/ImportContentJsonButton";
import type { ContentImportCollection } from "./types";

export function buildContentImportActions(
  importCollection: ContentImportCollection
) {
  return function ContentImportActions({
    collection,
  }: CollectionActionsProps) {
    return [
      <ImportContentJsonButton
        key="import-content-json"
        importCollection={importCollection}
        collection={collection as EntityCollection}
      />,
    ];
  };
}
